import { css, cx } from 'linaria';
import { classNames } from '@uds/typography';
import { Colorway, cssTheme } from '@uds/theme-utils';
import { Layout } from 'components/common/ProductPrice/constants';
import { contrastColor } from 'presentation/utils/colorway';

const intro = css`
  margin-top: ${cssTheme.gu2};
`;

const price = css`
  margin-right: ${cssTheme.gu1};
  display: inline;
`;

const renewal = css`
  display: inline;
}`;

const setupFee = {
  default: css`
    margin-top: ${cssTheme.gu1};
    margin-bottom: ${cssTheme.gu2};
  `,
  compact: css`
    text-align: right;
    margin-top: 0;
  `,
};

const root = css`
  margin-top: ${cssTheme.gu3};
  background: transparent; //parents set this
`;

const badge = css`
  margin-left: calc(-1 * ${cssTheme.gu1});
`;

export const getClassNames = ({ priceLayout }: { priceLayout?: Layout }) => {
  return {
    root,
    badge,
    fee: contrastColor,
    intro: cx(intro, classNames.content),
    price: cx(price, contrastColor),
    renewal,
    setupFee: cx(setupFee.default, priceLayout === Layout.COMPACT && setupFee.compact),
  };
};
const legalCaveat = css`
  margin-top: ${cssTheme.gu1};
  opacity: 0.9;
`;

const priceWrapper = css`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

const pricing = {
  compact: css`
    flex: 1;
    flex-basis: auto;
    text-align: right;
  `,
  noProposition: css`
    margin-top: ${cssTheme.gu2};
  `,
};

const specialColor = css`
  color: ${cssTheme.palette.primary};
`;

export default ({
  priceLayout,
  hasProposition,
  colorway,
  hasBadge,
}: {
  priceLayout?: Layout;
  hasProposition: boolean;
  colorway?: Colorway;
  hasBadge: boolean;
}) => {
  const badgeAndNoProposition = !hasProposition && priceLayout !== Layout.COMPACT && hasBadge;
  const colorPrice = [Colorway.NEUTRAL, Colorway.LIGHT].includes(colorway as Colorway);
  return {
    root,
    intro: cx(intro, classNames.content),
    fee: cx(colorPrice && specialColor),
    badge,
    price: cx(price, colorPrice && specialColor),
    legalCaveat: cx(legalCaveat, classNames.smallprint),
    renewal,
    priceWrapper: cx(priceLayout === Layout.COMPACT && priceWrapper),
    setupFee: cx(setupFee.default, priceLayout === Layout.COMPACT && setupFee.compact),
    pricing: cx(priceLayout === Layout.COMPACT && pricing.compact, badgeAndNoProposition && pricing.noProposition),
  };
};
